import firebaseService from 'Services/firebaseService';

export async function isEmailTaken(email) {
  const listOfSignInMethodsForEmail = await firebaseService.auth.fetchSignInMethodsForEmail(
    email,
  );
  return listOfSignInMethodsForEmail.length > 0;
}
